// @flow

/**
 * Defines the constants for the booking services.
 */
export default {

  HIDE_ACTION_UNTIL_IN_MINUTES: 30,

  /**
   * The source of the booking: where the booking have been made.
   */
  Source: {
    /**
     * The booking have been made on the PayMyTable mobile application.
     */
    APP: 0,

    /**
     * The booking have been made on the PayMyTable website.
     */
    WEBSITE: 1,

    /**
     * The booking have been made on the PayMyTable restaurant.
     */
    RESTAURANT: 2,

    /**
     * The booking have been made by phone call.
     */
    PHONE: 3,

    /**
     * The booking have been made by another way than the describes ones.
     */
    THIRD_PARTY: 4,

    /**
     * The booking have been made with the plugin.
     */
    PLUGIN: 5
  },

  /**
   * The status of the booking.
   */
  Status: {
    /**
     * The booking is waiting for validation.
     */
    WAITING: 0,

    /**
     * The booking is confirmed. When confirmed, the booking's action can be change.
     * See BookingConstants.Actions.
     */
    CONFIRMED: 1
  },

  /**
   * The current action for the booking.
   */
  Action: {
    /**
     * Default. The client is not arrived.
     */
    NOT_ARRIVED: 0,

    /**
     * The client is placed at the table.
     */
    SEATED: 1,

    /**
     * The booking is canceled.
     */
    CANCELED: 2,

    /**
     * The client haven't come to the restaurant.
     */
    NO_SHOW: 3
  },

  /**
   * The settings for the notifications.
   */
  NotificationType: {
    /**
     * The notifications will be send for each modifications and for automatic validations.
     */
    FOR_ALL: 0,

    /**
     * The notifications will be send for each modifications but not for automatic validations.
     */
    FOR_VALIDATE_ONLY: 1
  },

  State: {
    OPEN: 0,

    CLOSED: 1,

    FULL: 2
  },

  /**
   * Warning: if change, we also need to change on BookingViewUtils.
   */
  Period: {

    /**
     * Used to impact all the periods.
     */
    ALL: 0,

    MORNING: 1,

    NOON: 2,

    BRUNCH: 3,

    EVENING: 4
  }

};



// WEBPACK FOOTER //
// ./sdk/scripts/constants/BookingConstants.js